import { Injectable } from '@angular/core';
import { ChatAttachment, ChatMessage, ChatMessageResponse, Download, NewMessage } from 'cloud-shared-lib';
import { Observable, Subject } from 'rxjs';
import { BaseQuestion } from './models/question.model';

@Injectable()
export abstract class SupportChatService {
  abstract newMessagesSubject: Subject<ChatMessage>;
  abstract newAttachmentsSubject: Subject<ChatAttachment[]>;

  abstract getQuestion(questionId: number): Observable<BaseQuestion>;
  abstract getMessages(questionId: number, all: boolean): Observable<ChatMessageResponse>;
  abstract sendMessage(questionId: number, newMessage: NewMessage): Observable<ChatMessage>;
  abstract getAttachmentFile(questionId: number, messageId: number, attachment: number): Observable<Download>;
  abstract uploadFiles(files: File[], questionId: number, messageId: number): Observable<ChatAttachment[]>;
  abstract markAsRead(questionId: number): Observable<void>;
}
